import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IBillingState } from '@shared/models';
import { fetchPaymentPlans, fetchPaymentMethods, fetchInvoices } from '../queries';

const state: IBillingState = {
    paymentMethods: [],
    fetchingPaymentMethods: false,
    paymentPlans: [],
    fetchingPaymentPlans: false,
    transactions: {
        invoices: [],
        hasMore: false,
    },
    fetchingTransations: false,
    selectedPlanId: '',
};

const paymentSlice = createSlice({
    name: 'payment',
    initialState: state,
    reducers: {
        setPaymentMethods: (state, action: PayloadAction<IBillingState['paymentMethods']>) => {
            state.paymentMethods = action.payload;
        },
        setPaymentPlans: (state, action: PayloadAction<IBillingState['paymentPlans']>) => {
            state.paymentPlans = action.payload;
        },
        setInvoices: (state, action: PayloadAction<IBillingState['transactions']>) => {
            state.transactions = action.payload;
        },
        setSelectedPlanId: (state, action: PayloadAction<IBillingState['selectedPlanId']>) => {
            state.selectedPlanId = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchPaymentPlans.pending, (state) => {
            state.fetchingPaymentPlans = true;
        });
        builder.addCase(fetchPaymentPlans.rejected, (state) => {
            state.fetchingPaymentPlans = false;
        });
        builder.addCase(fetchPaymentPlans.fulfilled, (state) => {
            state.fetchingPaymentPlans = false;
        });
        builder.addCase(fetchPaymentMethods.pending, (state) => {
            state.fetchingPaymentMethods = true;
        });
        builder.addCase(fetchPaymentMethods.rejected, (state) => {
            state.fetchingPaymentMethods = false;
        });
        builder.addCase(fetchPaymentMethods.fulfilled, (state) => {
            state.fetchingPaymentMethods = false;
        });
        builder.addCase(fetchInvoices.pending, (state) => {
            state.fetchingTransations = true;
        });
        builder.addCase(fetchInvoices.rejected, (state) => {
            state.fetchingTransations = false;
        });
        builder.addCase(fetchInvoices.fulfilled, (state) => {
            state.fetchingTransations = false;
        });
    },
});

export const { setPaymentMethods, setPaymentPlans, setInvoices, setSelectedPlanId } = paymentSlice.actions;
export default paymentSlice.reducer;
